module.exports = __webpack_public_path__ + "static/03-059b0c360dce6febf0df0a913a35c6ee.jpeg";